export const REDUCER_PATHS = {
  AUTH: "auth",
  TOKEN: "token",
  USERS: "users",
  MASTER: "master",
  PROFILE: "profile",
  SETTINGS: "settings",
  ROLE: "role",
  EMAIL_TEMPLATES: "emailTemplates",
  BLOG: "blog",
  FILTER: "filter",
  SUPPORT: "support",
  SUBSCRIPTION: "subscription",
  DASHBOARD: "dashboard",
  PUSH_NOTIFICATION: "pushNotification",
  OUESTIONNAIRE: "questionnaire",
  WOUND_MANAGEMENT: "woundManagement",
};

export const REDUCER_TAGS = {
  POSTS: "Posts",
  PROFILE: "Profile",
  SETTINGS: "settings",
  USERS: "users",
};
